import { Fragment } from 'react';

import HideIcon from '@usas/ui-web/components/icons/HideIcon';
import ShowIcon from '@usas/ui-web/components/icons/ShowIcon';
import EditIcon from '@usas/ui-web/components/icons/EditIcon';
import Checkbox from '@usas/ui-web/components/checkboxes/Checkbox';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const DetailTableRow = ({ role, onUpdateIsTransferSelected }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableDetailRowHead}>
      <span className='hidden-xs'>{role.orgRoleName || <span>&nbsp;</span>}</span>&nbsp;
      {role.isTransferPending === false ?
        <div style={{ float: 'right' }}>
          <Checkbox
            label="Transfer"
            name={`isTransferSelected${role.personOrgRoleDurationId}`}
            checked={role.isTransferSelected}
            onChange={() => { onUpdateIsTransferSelected(role.personOrgRoleDurationId) }} />
        </div>
        : <span></span>
      }
    </div>
    <div className={global.SmallTableRowInfo}>
      <div className='row'>
        <div className={[global.SmallTableRowLabels, 'col-xs-7 visible-xs'].join(' ')}>Member Type</div>
        <div className={[global.SmallTableRowData, 'col-xs-5 visible-xs'].join(' ')}>{role.orgRoleName || <span>&nbsp;</span>}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-7'].join(' ')}>Registration Exp. Date</div>
        <div className={[global.SmallTableRowData, 'col-xs-5'].join(' ')}>{role.registrationExpirationDate || <span>&nbsp;</span>}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-7'].join(' ')}>Good Standing Exp. Date</div>
        <div className={[global.SmallTableRowData, 'col-xs-5'].join(' ')}>{role.isInGoodStandingExpirationDate || <span>&nbsp;</span>}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-7'].join(' ')}>Transfer Pending</div>
        <div className={[global.SmallTableRowData, 'col-xs-5'].join(' ')}>{role.isTransferPending === true ? 'Yes' : 'No'}</div>
      </div>
    </div>
  </div>
);

const DetailTable = ({ nonAthlete, onUpdateIsTransferSelected }) => (
  <div className={global.SmallTableDetailTable}>
    {Array.isArray(nonAthlete.roles) && nonAthlete.roles.map((role, i) =>
      <DetailTableRow
        key={i}
        role={role}
        onUpdateIsTransferSelected={onUpdateIsTransferSelected} />)
    }
  </div>
);

const SmallGridRow = ({ nonAthlete, expandedId, onEditNonAthlete, onUpdateIsSyncSelected, onUpdateIsTransferSelected, onExpandClicked }) => (
  <Fragment>
    <div className={global.SmallTableRow}>
      <div className={global.SmallTableRowHead}><span className='hidden-xs'>
        {(nonAthlete.firstName || nonAthlete.middleName || nonAthlete.lastName)
          ? `${nonAthlete.preferredName ? nonAthlete.preferredName : nonAthlete.firstName || ''} ${nonAthlete.lastName || ''}`
          : ''
        }</span>&nbsp;
        <button
          className={global.IconButtonMobileMargin}
          type="button"
          onClick={(e) => onExpandClicked(e, nonAthlete.personId)}>
          {expandedId === nonAthlete.personId ? <HideIcon /> : <ShowIcon />}
        </button>
        {onEditNonAthlete &&
          <button
            className={global.IconButton}
            type="button"
            onClick={() => onEditNonAthlete(nonAthlete.personId)}>
            <EditIcon />
          </button>
        }
        <Checkbox
          label="Sync"
          name={`isSyncSelected${nonAthlete.memberId}`}
          checked={nonAthlete.isSyncSelected}
          onChange={() => { onUpdateIsSyncSelected(nonAthlete.memberId) }} />
      </div>
      <div className={global.SmallTableRowInfo}>
        <div className='row'>
          <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>Name</div>
          <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>
            {(nonAthlete.firstName || nonAthlete.middleName || nonAthlete.lastName)
              ? `${nonAthlete.preferredName ? nonAthlete.preferredName : nonAthlete.firstName || ''} ${nonAthlete.lastName || ''}`
              : <span>&nbsp;</span>
            }
          </div>
          <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Birth Date</div>
          <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{nonAthlete.birthDate || <span>&nbsp;</span>}</div>
          <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Member Type(s)</div>
          <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{nonAthlete.orgRoleName || <span>&nbsp;</span>}</div>
        </div>
      </div>
    </div>
    {nonAthlete.personId === expandedId &&
      <DetailTable nonAthlete={nonAthlete} onUpdateIsTransferSelected={onUpdateIsTransferSelected} />
    }
  </Fragment>
);

const ClubNonAthleteRosterFormGridSmall = ({ formGridState, isLoading, expandedId, onEditNonAthlete, onUpdateIsSyncSelected, onUpdateIsTransferSelected, onExpandClicked }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>Loading...</div>
          </div>
        </div>
      ) : Array.isArray(formGridState) && formGridState.length > 0
        ? formGridState.map((nonAthlete, i) =>
          <SmallGridRow
            key={i}
            expandedId={expandedId}
            nonAthlete={nonAthlete}
            onEditNonAthlete={onEditNonAthlete}
            onUpdateIsSyncSelected={onUpdateIsSyncSelected}
            onUpdateIsTransferSelected={onUpdateIsTransferSelected}
            onExpandClicked={onExpandClicked} />
        ) : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Non Athletes</div>
            </div>
          </div>
        )
    }
  </div>
);

export default ClubNonAthleteRosterFormGridSmall;